import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'
import cn from 'classnames'

import Button from 'app/components/ButtonDefault'
import { ON_BOARDING_BRIEF_QUIZ_CONTENT as Content } from 'app/constants/onBoarding'

import './style.scss'
const bc = 'on-boarding-brief-quiz'

class OnBoardingBriefQuiz extends Component {
  static propTypes = {
    requestSurvey: PropTypes.func.isRequired,
    showTypeFormPopup: PropTypes.func.isRequired,
    isFirstLogin: PropTypes.bool.isRequired,
    beginSurveyLink: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]).isRequired,
  }

  componentWillUnmount() {
    const { queries } = this.props
    if (queries && queries.get('isReadyToRunTour')) {
      this.props.setRun(true)
    }
  }

  maybeLaterHandler = () => {
    this.props.hideModal()
    this.props.requestSurvey(true)
  }

  render() {
    const { t, i18n: { language }, showTypeFormPopup, beginSurveyLink } = this.props
    return (
      <div className={`${bc}`}>
        <div className={`${bc}__title`}>{t('Brief quiz (1 min)')}</div>
        <div className={`${bc}__content`}>
          <p className={`${bc}__text`}>{t('This quiz will ask you questions')}</p>
          <div className={`${bc}__img`}>
            <img src={Content.src} alt={Content.src} />
          </div>
          <p className={`${bc}__philosof-text`}>{t(Content.philosofText)}</p>
          <div className={`${bc}__philosof-name`}>{Content.philosofName}</div>
        </div>

        <div
          className={cn(`${bc}__buttons`, {
            [`${bc}__buttons__${language}`]: language,
          })}
        >
          <Button
            primary
            className={`${bc}__btn ${bc}__btn--quiz`}
            onClick={showTypeFormPopup}
            disabled={!beginSurveyLink}
            submitting={!beginSurveyLink}
          >
            {t('Take Brief Quiz')}
          </Button>
          <Button className={`${bc}__btn ${bc}__btn--later`} onClick={this.maybeLaterHandler}>
            {t('Maybe Later')}
          </Button>
        </div>
      </div>
    )
  }
}

export default withTranslation('user')(OnBoardingBriefQuiz)
